import {
  Alert,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Slide,
  Snackbar,
  TextField,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useContext, useEffect, useState } from "react";
import uploadFileToBlob from "../../../../services/AzureStorage";
import { PlayerProfileService } from "../../../../services/playerProfile.Service";
import UploadImagePopup from "../../../../sharedComponents/uploadImage/uploadImagePopup";
// // import DateAdapter from "@mui/lab/AdapterMoment";
// import DateAdapter from "@mui/lab/AdapterDateFns";
// import DatePicker from "@mui/lab/DatePicker";
// import LocalizationProvider from "@mui/lab/LocalizationProvider";

//Date related importes
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

import { AppDataContext } from "../../../../common/appContext";

//UPLOAD EXCEL ICONS.

//UPLOAD EXCEL 3rd PARTY LIBRARIES.
import ExcelJs from "exceljs";
import * as React from "react";
import { v1 as uuidv1 } from "uuid";

//UPLOAD EXCEL SERVICE IMPORTS.
import { uploadGameScoreFileToBlob } from "../../../../services/AzureStorage";
import { GameScoreServices } from "../../../../services/gameScore.Services";
import Loader from "../../../../sharedComponents/loader/loader";
import BasicAnthroComponent from "./BasicAnthroComponent";
import ParticipationTypeComponent from "./ParticipationTypeComponent";
import PlayerFileUpload from "./PlayerFileUpload";
import ResidenceComponent from "./ResidenceComponent";
import SocialMediaComponent from "./SocialMediaComponent";
import AppConstatnts from "../../../../common/AppConstants";

export const useStyles = makeStyles((theme) => ({
  firstSectionTitle: {
    fontWeight: "500",
    color: "#1d428a",
  },
  label: {
    "& .MuiFormControlLabel-label": {
      fontSize: "0.9rem",
      color: "grey",
      //   whiteSpace: "nowrap",
    },
  },
}));

//UPLOAD EXCEL CONFIGURATIONS.
const MAX_SHEET_COLUMN_LENGTH = 4;
const ALLOWED_SHEET_COLUMN_NAMES = [
  "Time (s)",
  "Left (N)",
  "Right (N)",
  "Combined (N)",
];

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

//--Main Component-----------------------------------------------------------
const UpdatePLayerDetails = (props) => {
  const classes = useStyles();
  const { playerID, playerData, user } = props;
  const { combineYear, selectedEventId, commonEventList } =
    useContext(AppDataContext);

  //BULK EXCEL COUNTER MOVEMENTS DATA HOLDERS.
  const elementFileRef = React.useRef(null);
  const allowedFileExtensions = ["xlsx", "xls"];
  const [openCounterMmtUpload, setOpenCounterMmtUpload] = useState(false);
  const [isUploadBtnInProgress, setIsUploadBtnInProgress] = useState(false);
  const [displayFileName, setDisplayFileName] = useState(null);
  const [finalFileName, setFinalFileName] = useState(null);
  const [sheetData, setSheetData] = useState([]);
  const [counterMovementStation, setCounterMovementStation] = useState("");
  const [sheetUploadError, setSheetUploadError] = useState({
    error: false,
    errorMsg: "",
  });

  //UPLOAD PLAYER PHI DOCUMENTS DATA HOLDERS.
  const elementPHIFileRef = React.useRef(null);
  const allowedPHIFileExtensions = ["pdf", "doc", "docx", "json"];
  const [openPHIDocumentUpload, setOpenPHIDocumentUpload] = useState(false);
  const [isPHIUploadBtnInProgress, setIsPHIUploadBtnInProgress] =
    useState(false);
  const [displayPHIFileName, setDisplayPHIFileName] = useState(null);
  const [finalPHIFileName, setFinalPHIFileName] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [formData, setformData] = useState({});
  const [openUploadImage, setOpenUploadImage] = useState(false);
  const [playerPOD, setPlayerPod] = useState({
    podName: "",
    podNumber: "",
  });
  const [dropDownData, setDropDownData] = useState({
    country: [],
    state: [],
    pod: [],
    position: [],
    counterMovementStation: [],
  });
  const [alert, setAlert] = useState({
    alertOpen: false,
    alertType: "",
    alertMessage: "",
  });

  //GET ALL THE DROP DOWN DATA ON INITIAL LOAD
  useEffect(async () => {
    fetchDropdownDataforPlayer();
  }, []);

  //1. set the playerData to formData for maintaning state changes
  //2. find any event with POD and set state of playerPOD, it is common for all events
  useEffect(() => {
    setformData({
      playerID: playerID,
      playerName: playerData.playerName || "",
      collegeOrClub: playerData.collegeOrClub || "",
      headshotURL: playerData.headshotURL || "",
      countryId: playerData.countryId || 0,
      stateId: playerData.stateId || 0,
      state_Other: playerData.state_Other || "",
      address1: playerData.address1 || "",
      address2: playerData.address2 || "",
      address3: playerData.address3 || "",
      address4: playerData.address4 || "",
      zip: playerData.zip || "",
      dob: playerData.dob ? dayjs(playerData.dob).format("YYYY-MM-DD") : null,
      heightInFeet: parseFloat(playerData.heightInFeet || 0),
      heightInInches: parseFloat(playerData.heightInInches || 0),
      weight: parseFloat(playerData.weight) || 0,
      positionId: parseInt(playerData.positionId || 0),
      participate: playerData.participate || [],
      twitter: playerData.twitter || "",
      instagram: playerData.instagram || "",
      userBy: user.loginID,
    });
    const result = playerData.participate?.find((p, i) => {
      return p.mode !== "delete";
    });
    result
      ? setPlayerPod({
          podName: result.podName || "",
          podNumber: result.podNumber || "",
        })
      : resetPlayerPOD();
  }, [playerData]);

  //---UTILs---

  const toggleAlert = (open, type, message) => {
    setAlert({
      alertOpen: open,
      alertType: type,
      alertMessage: message,
    });
  };

  const resetAlert = () => {
    toggleAlert(false, "", "");
  };

  // When playerPOD is disabled,i.e. when no events are checked, reset the values
  const resetPlayerPOD = () => {
    setPlayerPod({
      ...playerPOD,
      podName: "",
      podNumber: "",
    });
  };

  //---to check if participation is empty or not---
  const validateParticipation = () => {
    return (
      formData.participate?.length === 0 ||
      checkIfPlayerPODDisabled(formData.participate)
    );
  };

  //save button is enabled if any of the field has value or any event is checked
  const checkIfSaveButtonDisabled = () => {
    return !validateParticipation() ||
      formData.countryId ||
      formData.stateId ||
      formData.state_Other ||
      formData.address1 ||
      formData.address2 ||
      formData.zip ||
      formData.dob ||
      formData.heightInFeet ||
      formData.heightInInches ||
      formData.weight ||
      formData.positionId ||
      formData.twitter ||
      formData.instagram
      ? false
      : true;
  };

  //1. finds the given event from participation
  //2. returns participated event object if found, else returns undefined
  //3. helps to decide check and unchecked values of events, and get the jersey no. for checked events
  function getParticipatedEvent(eventId) {
    const result = formData.participate?.find((p, i) => {
      return p.eventId === eventId && p.mode !== "delete";
    });
    return result;
  }

  //1. determines the checked or unchecked value of event
  const checkIfParticipated = (eventId) => {
    return getParticipatedEvent(eventId) ? true : false;
  };

  //1. get the event if participated
  //2. if participated then return jersey number, or empty string
  const getJerseyNumber = (eventId) => {
    const result = getParticipatedEvent(eventId);
    return result ? result.jersey : "";
  };

  //1. check if any of the event is selected
  //2. to determine PlayerPOD disabled or not
  const checkIfPlayerPODDisabled = (participation) => {
    const result = participation?.filter((p, i) => {
      return p.mode !== "delete";
    });
    return result?.length === 0;
  };

  //---COunter movement file utils---

  const handleCounterMmtStationChange = (e) => {
    setCounterMovementStation(e.target.value);
  };

  const clearFileInput = () => {
    elementFileRef.current.value = null;
    setFinalFileName(null);
    setDisplayFileName(null);
    setSheetUploadError({
      error: false,
      errorMsg: "",
    });
  };

  const validateSheetData = (sheetCols, sheetData) => {
    //ADDED CHECK FOR SHEET COLUMN LENGTH
    if (sheetCols.length !== MAX_SHEET_COLUMN_LENGTH) {
      setSheetUploadError({
        error: true,
        errorMsg: `The no. of sheet columns should be ${MAX_SHEET_COLUMN_LENGTH}.`,
      });
      return false;
    }

    //ADDED CHECK FOR SHEET COLUMN NAMES.
    if (!sheetCols.every((name) => ALLOWED_SHEET_COLUMN_NAMES.includes(name))) {
      setSheetUploadError({
        error: true,
        errorMsg: `The Sheet column names should be 'Time (s)', 'Left (N)','Right (N)', and 'Combined (N)' only.`,
      });
      return false;
    }

    //ADDED CHECK FOR SHEET DATA.
    if (sheetData.length === 0) {
      setSheetUploadError({
        error: true,
        errorMsg: `The sheet cannot be empty..`,
      });
      return false;
    }
    return true;
  };

  const formatJsonData = (headers, values) => {
    return values.map((row) => {
      return headers.reduce((obj, header, index) => {
        obj[header] = row[index];
        return obj;
      }, {});
    });
  };

  const readExcelFile = async (file) => {
    const workbook = new ExcelJs.Workbook();
    await workbook.xlsx.load(file);

    var mySheetData = [];
    workbook.eachSheet((worksheet, sheetId) => {
      const iAttemptID = sheetId;
      const rowsData = [];

      worksheet.eachRow((row, rowNumber) => {
        const rowData = [];
        row.eachCell((cell, colNumber) => {
          rowData.push(cell.value);
        });
        rowsData.push(rowData);
      });

      const sheetRawColumns = rowsData[0];
      const jsonData = rowsData.slice(1);

      //VALIDATE SHEET
      const status = validateSheetData(sheetRawColumns, jsonData);

      //GET PRE formatted JSON DATA
      const preFormatedData = formatJsonData(sheetRawColumns, jsonData);

      //PREPARE JSON OBJECT IF DATA VALIDATAED SUCCESSFULY.
      if (status) {
        const newJsonData = preFormatedData.map((data) => ({
          left: "" + data["Left (N)"],
          right: "" + data["Right (N)"],
          combined: "" + data["Combined (N)"],
          time: "" + data["Time (s)"],
          eventId: parseInt(selectedEventId),
          stationId: parseInt(counterMovementStation),
          playerID: parseInt(playerID),
          attempt: iAttemptID,
          userBy: user.loginID,
          createdDate: new Date(),
        }));
        mySheetData.push(...newJsonData);
      }
    });
    //Assign data from sheet to object
    setSheetData(mySheetData);
  };

  const handleCounterMovementDocumentChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      let blob = file.slice(0, file.size, file.type);
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);

      //#Extention Validation
      if (!allowedFileExtensions.includes(extension.toLowerCase())) {
        toggleAlert(
          true,
          "warning",
          `Please select files with one of ${allowedFileExtensions.join(
            ", "
          )} formats.`
        );
        clearFileInput();
        return;
      }

      //Read Excel Sheet data.
      await readExcelFile(file);

      //Set Display filename.
      setDisplayFileName(file.name.replace(`.${extension}`, ""));

      //Set new filename.
      let newFileName = uuidv1() + "." + extension;

      const newFile = new File([blob], newFileName, { type: file.type });
      setFinalFileName(newFile);
    }
  };

  //--PHI Document utils---

  const clearPHIFileInput = () => {
    elementPHIFileRef.current.value = null;
    setFinalPHIFileName(null);
    setDisplayPHIFileName(null);
  };

  const createPHIDetailsFormData = () => {
    const PHIDetails = new FormData();
    PHIDetails.append("docId", 0);
    PHIDetails.append("EventId", selectedEventId);
    PHIDetails.append("DocType", "DexaBodyFat");
    PHIDetails.append(
      "FileExtension",
      finalPHIFileName.name.substring(
        finalPHIFileName.name.lastIndexOf(".") + 1
      )
    );
    PHIDetails.append("DocumentName", null);
    PHIDetails.append("DisplayName", displayPHIFileName);
    PHIDetails.append("IsDeleted", false);
    PHIDetails.append("IsPublished", false);
    PHIDetails.append("CreatedDate", new Date());
    PHIDetails.append("UserBy", user.loginID);
    PHIDetails.append("Mode", "");
    PHIDetails.append("StationId", 108);
    PHIDetails.append("PlayerID", parseInt(playerID));
    PHIDetails.append("media", finalPHIFileName);
    return PHIDetails;
  };

  const handlePHIDocumentChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      let blob = file.slice(0, file.size, file.type);
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);

      //#Extention Validation
      if (!allowedPHIFileExtensions.includes(extension.toLowerCase())) {
        toggleAlert(
          true,
          "warning",
          `Please select files with one of ${allowedPHIFileExtensions.join(
            ", "
          )} formats.`
        );
        clearPHIFileInput();
        return;
      }
      //#Set Display filename.
      setDisplayPHIFileName(file.name.replace(`.${extension}`, ""));

      //#Set new filename.
      let newFileName = uuidv1() + "." + extension;

      const newFile = new File([blob], newFileName, { type: file.type });
      setFinalPHIFileName(newFile);
    }
  };

  //---HANDLERS---

  const handleOpenCloseUploadImage = (val) => {
    setOpenUploadImage(val);
  };

  const handleOpenCloseCounterMmtUpload = (val) => {
    if (val === false) {
      clearFileInput();
      setCounterMovementStation("");
    }
    setOpenCounterMmtUpload(val);
  };

  const handleOpenClosePHIDocumentUpload = (val) => {
    if (val === false) {
      clearPHIFileInput();
    }
    setOpenPHIDocumentUpload(val);
  };

  const handleInputChange = (e, key) => {
    let value = e?.target?.value;
    let defaultVal = "";
    switch (key) {
      case "dob":
        value = e ? dayjs(e).format("YYYY-MM-DD") : null;
        defaultVal = null;
        break;
      case "heightInFeet":
        value = value.replace(AppConstatnts.VALIDATIONS.NOT_DECIMAL_REGEX, "");
        break;
      case "heightInInches":
        if (value && parseFloat(value) > 11.99) return;
        break;
      case "stateId":
      case "positionId":
      case "countryId":
        defaultVal = 0;
        break;
    }
    setformData({
      ...formData,
      [key]: value || defaultVal,
    });
  };

  //1. find the PodName from pod dropdown list
  //2. set the pod values
  //3. set the pod values to each participated event
  const handlePODChange = (e) => {
    const pod = dropDownData.pod.find((p, i) => {
      return p.childID === e.target.value;
    });
    setPlayerPod({
      podNumber: pod.childID,
      podName: pod.childName,
    });
    const updatedParticipation = formData.participate?.map((p, i) => {
      return p.mode !== "delete"
        ? {
            ...p,
            podName: pod.childName === "None" ? "" : pod.childName,
            podNumber: pod.childID || null,
          }
        : p;
    });
    setformData({
      ...formData,
      participate: [...updatedParticipation],
    });
  };

  //1. find the selected event with given eventId
  //2. set the jersey no value for that event and update the participation
  const handleJerseyNoInput = (value, eventId) => {
    const updatedparticipation = formData.participate?.map((p) =>
      p.eventId === eventId && p.mode !== "delete"
        ? { ...p, jersey: value || null }
        : p
    );
    setformData({
      ...formData,
      participate: updatedparticipation,
    });
  };

  //1. if already checked then uncheck and set mode to delete
  //2. if not checked, then check or re-check it and set mode to null
  //3. set the POD as well for checked events
  //4. if all are unchecked then POD is reset
  const handleParticipationTypeChange = (eventId) => {
    const result = formData.participate?.find((p, i) => {
      return p.eventId === eventId;
    });
    if (result) {
      const updatedParticipation = formData.participate?.map((p) =>
        p.eventId === eventId
          ? p.mode === "delete"
            ? {
                ...p,
                mode: null,
                podNumber: playerPOD.podNumber || null,
                podName: playerPOD.podNumber ? playerPOD.podName : "",
              }
            : {
                ...p,
                mode: "delete",
                jersey: null,
                podNumber: null,
                podName: "",
              }
          : p
      );
      setformData({
        ...formData,
        participate: updatedParticipation,
      });
      if (checkIfPlayerPODDisabled(updatedParticipation)) {
        resetPlayerPOD();
      }
    } else {
      setformData({
        ...formData,
        participate: [
          ...formData.participate,
          {
            playerID: playerID,
            eventId: eventId,
            jersey: null,
            podNumber: playerPOD.podNumber || null,
            podName: playerPOD.podName === "None" ? "" : playerPOD.podName,
            mode: null,
            userBy: user.loginID,
            team: null,
          },
        ],
      });
    }
  };

  //---APIs---
  const fetchDropdownDataforPlayer = async () => {
    const [countryList, stateList, podList, positionList, counterMmtList] =
      await Promise.all([
        PlayerProfileService.getPlayerCountryList(),
        PlayerProfileService.getPlayerStateList(),
        PlayerProfileService.getPLayerPODDetails(),
        PlayerProfileService.getPlayerPositions(),
        PlayerProfileService.getCounterMovementsStatisons(),
      ]);

    const newStationData = counterMmtList.data.filter((station) =>
      [204, 205].includes(station.childID)
    );
    setDropDownData({
      ...dropDownData,
      country: [{ childID: "", childName: "None" }, ...countryList.data],
      state: [{ childID: "", childName: "None" }, ...stateList.data],
      pod: [{ childID: "", childName: "None" }, ...podList.data],
      position: [{ childID: "", childName: "None" }, ...positionList.data],
      counterMovementStation: [...newStationData],
    });
  };

  const handleUploadPHIDocument = async () => {
    if (!finalPHIFileName) {
      toggleAlert(true, "warning", "Please choose a file to upload");
      return;
    }
    setIsPHIUploadBtnInProgress(true);
    try {
      const PHIDetails = createPHIDetailsFormData();
      await GameScoreServices.savePlayerDexaBodyFatDocuments(PHIDetails);
      toggleAlert(true, "success", "Document uploaded successfully.");
      handleOpenClosePHIDocumentUpload(false);
    } catch (error) {
      toggleAlert(
        true,
        "error",
        "Something went wrong while uploading the file."
      );
    } finally {
      setIsPHIUploadBtnInProgress(false);
    }
  };

  const handleUploadCounterData = async () => {
    if (!counterMovementStation) {
      toggleAlert(true, "warning", "Please choose station for upload.");
      return;
    }
    if (!finalFileName) {
      toggleAlert(true, "warning", "Please choose file to upload.");
      return;
    }
    if (sheetData.length === 0) {
      toggleAlert(true, "error", "Error while reading the sheet data.");
      return;
    }
    setIsUploadBtnInProgress(true);
    try {
      const isBlobUploaded = await uploadGameScoreFileToBlob(finalFileName);
      if (isBlobUploaded) {
        const { data: iDocumentUploadRes } =
          await GameScoreServices.uploadGameScoreDocument({
            docId: 0,
            eventId: selectedEventId,
            docType: "CounterMovements",
            fileExtension: finalFileName.name.substring(
              finalFileName.name.lastIndexOf(".") + 1
            ),
            documentName: finalFileName.name,
            displayName: displayFileName,
            isDeleted: false,
            isPublished: false,
            userBy: user.loginID,
            mode: "",
          });
        if (iDocumentUploadRes > 0) {
          const newArray = sheetData.map((obj) => {
            return {
              ...obj,
              docId: iDocumentUploadRes,
              documentName: "",
            };
          });

          await GameScoreServices.insertCounterMovements(newArray);
          toggleAlert(true, "success", "Details added successfully....");
          setIsUploadBtnInProgress(false);
          handleOpenCloseCounterMmtUpload(false);
        }
      }
    } catch (error) {
      setIsUploadBtnInProgress(false);
      toggleAlert(true, "error", "Something went wrong while uploading file.");
      console.log("error", error);
    }
  };

  const handleUploadImage = async (file) => {
    if (file.size >= 5000000) {
      toggleAlert(
        true,
        "error",
        "Image size exceeds 5MB, please upload a smaller file."
      );
      return;
    }
    try {
      const isUploaded = await uploadFileToBlob(file);
      if (isUploaded) {
        const result = await PlayerProfileService.updateProfileImageName({
          playerID: playerID,
          headshotURL: file.name,
          userBy: user.loginID,
        });
        if (result.data) {
          setformData({
            ...formData,
            headshotURL: file.name,
          });
          toggleAlert(true, "success", "Profile image updated successfully.");
        }
      }
    } catch (error) {
      console.log(error);
    }
    handleOpenCloseUploadImage(false);
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    if (!checkIfSaveButtonDisabled()) {
      try {
        const result =
          await PlayerProfileService.insertUpdatePlayerProfileDetails(formData);
        if (result) {
          toggleAlert(
            true,
            "success",
            "Personal details updated successfully."
          );
        }
      } catch (error) {
        console.log(error);
        toggleAlert(true, "error", "Something went wrong.");
      } finally {
        setIsLoading(false);
      }
    }
  };
  return (
    <>
      <Paper elevation={5}>
        {isLoading && <Loader isLoading={isLoading}></Loader>}
        <Grid container pl={2} pt={1} pb={1.3} pr={2} spacing={3}>
          {/* PLAYER PROFILE IMAGE, PARTICIPATION TYPE, JERSEY NO. */}
          <Grid item lg={3.3} md={5} sm={12} xs={12}>
            <ParticipationTypeComponent
              formData={formData}
              commonEventList={commonEventList}
              handleOpenCloseUploadImage={handleOpenCloseUploadImage}
              checkIfParticipated={checkIfParticipated}
              handleParticipationTypeChange={handleParticipationTypeChange}
              getJerseyNumber={getJerseyNumber}
              handleJerseyNoInput={handleJerseyNoInput}
            />
          </Grid>
          {/* PLAYER RESIDENCE, COUNTER MOVEMENTS AND PHI FILE UPLOAD */}
          <Grid item lg={4.9} md={7} sm={12} xs={12}>
            <ResidenceComponent
              formData={formData}
              playerPOD={playerPOD}
              user={user}
              checkIfPlayerPODDisabled={checkIfPlayerPODDisabled}
              handleOpenCloseCounterMmtUpload={handleOpenCloseCounterMmtUpload}
              handleOpenClosePHIDocumentUpload={
                handleOpenClosePHIDocumentUpload
              }
              handleInputChange={handleInputChange}
              handlePODChange={handlePODChange}
              dropDownData={dropDownData}
            />
          </Grid>
          {/* BASIC ANTHRO */}
          <Grid item lg={2.3} md={12} sm={12} xs={12}>
            <BasicAnthroComponent
              formData={formData}
              handleInputChange={handleInputChange}
              dropDownData={dropDownData}
            />
          </Grid>
          {/* SOCIAL MEDIA */}
          <Grid item lg={1.5} md={6} sm={6} xs={12}>
            <SocialMediaComponent
              formData={formData}
              checkIfSaveButtonDisabled={checkIfSaveButtonDisabled}
              handleSubmit={handleSubmit}
              handleInputChange={handleInputChange}
            />
          </Grid>
        </Grid>
      </Paper>
      {/* Profile Image upload dialog box */}
      <UploadImagePopup
        open={openUploadImage}
        title="Upload Image"
        handleClose={() => {
          setOpenUploadImage(false);
        }}
        changeProfilePhoto={handleUploadImage}
      />
      {/* Counter movement file upload dialog box */}
      <PlayerFileUpload
        ref={elementFileRef}
        title="Counter movement"
        open={openCounterMmtUpload}
        TransitionComponent={Transition}
        onClose={() => {
          handleOpenCloseCounterMmtUpload(false);
        }}
        onChange={handleCounterMovementDocumentChange}
        handleUpload={handleUploadCounterData}
        clearFileInput={clearFileInput}
        finalFileName={finalFileName}
        isUploadBtnInProgress={isUploadBtnInProgress}
        counterMovementList={dropDownData.counterMovementStation}
        counterMovementStation={counterMovementStation}
        handleCounterMmtStationChange={handleCounterMmtStationChange}
        sheetUploadError={sheetUploadError}
        allowedFileExtensions={allowedFileExtensions}
      />
      {/* PHI document upload dialog box */}
      <PlayerFileUpload
        ref={elementPHIFileRef}
        title="PHI Document"
        open={openPHIDocumentUpload}
        TransitionComponent={Transition}
        onClose={() => {
          handleOpenClosePHIDocumentUpload(false);
        }}
        onChange={handlePHIDocumentChange}
        handleUpload={handleUploadPHIDocument}
        clearFileInput={clearPHIFileInput}
        finalFileName={finalPHIFileName}
        isUploadBtnInProgress={isPHIUploadBtnInProgress}
        allowedFileExtensions={allowedPHIFileExtensions}
      />
      <Snackbar
        open={alert.alertOpen}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={2000}
        onClose={resetAlert}
      >
        <Alert
          onClose={resetAlert}
          severity={alert.alertType}
          sx={{ width: "100%" }}
        >
          {alert.alertMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default React.memo(UpdatePLayerDetails);
